import { render, staticRenderFns } from "./EditTaskModal.vue?vue&type=template&id=adf484ac"
import script from "./EditTaskModal.vue?vue&type=script&lang=js"
export * from "./EditTaskModal.vue?vue&type=script&lang=js"
import style0 from "./EditTaskModal.vue?vue&type=style&index=0&id=adf484ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports